<template>
  <main class="help">
    <h1>{{ copy.title }}</h1>
    <p>{{ copy.intro }}</p>
    <a class="help-main-link" href="mailto:contact@wellnotes.ai?subject=Help%20with%20the%20application&body=Hello%20support%20team,%0A%0AI%20need%20help%20with...">
      {{ copy.contactSupport }}
    </a>

    <p class="help-legal-label">{{ copy.legalLabel }}</p>
    <div class="help-legal-links">
      <a :href="`mailto:contact@wellnotes.ai?subject=Privacy%20request%20-%20${brand}`">
        {{ copy.privacyRequest }}
      </a>
      <a :href="`mailto:contact@wellnotes.ai?subject=Copyright%20or%20IP%20report%20-%20${brand}`">
        {{ copy.ipReport }}
      </a>
      <a :href="`mailto:contact@wellnotes.ai?subject=Security%20report%20-%20${brand}`">
        {{ copy.securityReport }}
      </a>
    </div>
  </main>
  <AppFooter />
</template>

<script>
import AppFooter from "../components/AppFooter.vue";

export default {
  name: "HelpPage",
  components: {
    AppFooter,
  },
  computed: {
    brand() {
      const rawLocale = this.$i18n?.locale;
      const locale =
        (typeof rawLocale === "string" ? rawLocale : rawLocale?.value) || "en";
      return locale.startsWith("fr") ? "Wellnotes" : "Wellnotes";
    },
    copy() {
      const rawLocale = this.$i18n?.locale;
      const locale =
        (typeof rawLocale === "string" ? rawLocale : rawLocale?.value) || "en";
      const isFr = locale.startsWith("fr");

      if (isFr) {
        return {
          title: "Aide",
          intro: "Si vous avez des questions ou des inquietudes, n'hesitez pas a nous contacter.",
          contactSupport: "Contacter le support par email",
          legalLabel: "Demandes juridiques et conformite",
          privacyRequest: "Demande RGPD (acces, suppression, rectification)",
          ipReport: "Signalement copyright ou propriete intellectuelle",
          securityReport: "Signalement securite ou abus",
        };
      }

      return {
        title: "Help",
        intro: "If you have questions or concerns, do not hesitate to reach out.",
        contactSupport: "Contact support via email",
        legalLabel: "Legal and compliance requests",
        privacyRequest: "Privacy rights request (access, deletion, correction)",
        ipReport: "Copyright or intellectual property report",
        securityReport: "Security or abuse report",
      };
    },
  },
};
</script>

<style scoped>
.help {
  text-align: center;
  padding: 88px 20px 48px;
  color: var(--app-text);
}

a {
  color: var(--app-link);
  text-decoration: none;
  font-size: 18px;
  display: inline-block;
}

.help-main-link {
  margin-top: 20px;
}

.help-legal-label {
  margin-top: 28px;
  margin-bottom: 6px;
  font-weight: 600;
}

.help-legal-links {
  margin-top: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
}

.help-legal-links a {
  font-size: 17px;
  line-height: 1.4;
}

a:hover {
  color: var(--app-link-hover);
  text-decoration: underline;
}
</style>
